import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

/**
 * Used to enable sticky header styles only when the user has actually scrolled
 */
export function useIsParentScrolled(scrollParentRef?: React.RefObject<HTMLDivElement>) {
  const [isParentScrolled, setIsParentScrolled] = useState(false);

  const debouncedSetIsParentScrolled = useMemo(
    () => debounce(setIsParentScrolled, 100, { leading: true }),
    [setIsParentScrolled]
  );

  useEffect(() => {
    const scrollParent = scrollParentRef?.current;

    const handleScroll = () => {
      const isScrolled = (scrollParent?.scrollTop ?? 0) > 0;

      if (isScrolled && !isParentScrolled) {
        debouncedSetIsParentScrolled(true);
        return;
      }

      if (!isScrolled && isParentScrolled) {
        debouncedSetIsParentScrolled(false);
      }
    };

    scrollParent?.addEventListener("scroll", handleScroll);

    return () => {
      scrollParent?.removeEventListener("scroll", handleScroll);
    };
  }, [isParentScrolled, scrollParentRef, debouncedSetIsParentScrolled]);

  return isParentScrolled;
}
